import React from "react";
import { CitationNode } from "./types";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";

export interface CitationProps {
    node: CitationNode;
    onClick: (node: CitationNode) => void;
}

const InlineCitationButton: React.FC<CitationProps> = ({ node, onClick }) => {
    return (
        <sup className="c-inline-citation-button">
            <Button onClick={() => onClick(node)} style={ButtonStyles.Text}>
                ({node.properties.displayNumber})
            </Button>
        </sup>
    );
};

export default InlineCitationButton;
